<template>
  <!-- 评价弹窗 -->
  <el-dialog title="服务评价" :visible.sync="dialogVisible" width="600px" :before-close="close">
    <div class="set_evalate" v-if="details">
      <el-form ref="details" :model="details" label-width="80px">
        <div class="flex_left">
          <span>商品评分：</span>
          <span style="width:200px;">
            <el-rate :disabled="viewReviews" :colors="['#FF733C','#FF733C','#FF733C']" v-model="details.grade"></el-rate>
          </span>
        </div>
        <div>
          <el-form-item
            prop="content"
            :rules="[{required: true, message: '请输入评价内容', trigger: 'blur'},{ min: 5, max: 150, message: '长度在 5 到 150 个字符', trigger: 'blur' }]"
          >
            <el-input
              type="textarea"
              :disabled="viewReviews"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入评价内容"
              v-model="details.content"
              maxlength="150"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
        <div style="text-align:right;padding-top: 15px;">
          <el-checkbox :disabled="viewReviews" v-model="details.anonymous">匿名评价</el-checkbox>
        </div>
        <div>
          <div style="line-height:24px;font-weight: 600;">店铺评分</div>
          <div class="flex_left">
            <span style="line-height:24px;font-weight: 500;">专业：</span>
            <el-rate :disabled="viewReviews" :colors="['#FF733C','#FF733C','#FF733C']" v-model="details.score_major"></el-rate>
          </div>
          <div class="flex_left">
            <span style="line-height:24px;font-weight: 500;">服务：</span>
            <el-rate :disabled="viewReviews" :colors="['#FF733C','#FF733C','#FF733C']" v-model="details.score_service"></el-rate>
          </div>
          <div class="flex_left">
            <span style="line-height:24px;font-weight: 500;">速度：</span>
            <el-rate :disabled="viewReviews" :colors="['#FF733C','#FF733C','#FF733C']" v-model="details.score_speed"></el-rate>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">暂不评价</el-button>
      <el-button type="primary" @click="submitForm('details')" :disabled="viewReviews">提交评价</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      default: true
    },
    //评价数据
    details: {
      type:Object
    },
    //true 查看评价详情 false进行评价
    viewReviews:{
      type:Boolean
    },
    //是否是其他订单评价(分为服务商品订单评价和其他订单评价，接口不同)
    otherapi:{
      type:Boolean
    }
  },
  methods: {
    /** 提交*/
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.subGrade('details')
        } else {
          this.$message("请检查必填字段是否已填写");
          return false;
        }
      });
    },
    /* 订单评价 */
    subGrade(formName) {
      var arr = [
        "ScoreGrade",
        "ScoreGradeOneStar",
        "ScoreGradeTwoStar",
        "ScoreGradeThreeStar",
        "ScoreGradeFourStar",
        "ScoreGradeFiveStar"
      ];
      console.log(this.details)
      if (!this.details.id) {
        this.$message({
          type: "info",
          message: "该订单不存在!"
        });
        return;
      }
      let params = {
        //service_order: this.details.id,
        grade: arr[this.details.grade], //商品评分
        score_major: arr[this.details.score_major], //专业评分
        score_service: arr[this.details.score_service], //服务评分
        score_speed: arr[this.details.score_speed], //速度评分
        anonymous: this.details.anonymous,
        content: this.details.content, //评价内容
        user_id: this.details.user_id,
        user_sale: this.details.user_sale_id,
        active: true
      };
      let _url = '';
      if(this.otherapi){//其他订单
        _url = this.api.createOrderScore;
        params.order = this.details.id;
        params.service_order && delete params.service_order
      }else{//服务商品订单
        _url = this.api.createServiceOrderScore;
        params.service_order = this.details.id;
        params.order && delete params.order
      }
      console.log(_url)
      _url(params, true).then(
        res => {
          if (res.error.err_code !== 0) return;
          this.$message({
            type: "success",
            message: "评价成功!"
          });
          //this.setHaveEvaluation(this.form.row);
          this.$emit("close", {
            name: "evalate",
            dialogVisible: false
          });
        }
      );
    },
    close() {
      this.$emit("close", {
        name: "evalate",
        dialogVisible: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.set_evalate {
  .flex_left {
    padding-bottom: 15px;
    line-height: 14px;
    font-weight: 600;
    display: flex;
  }
}
</style>